import React, { useState } from 'react';
import { Header } from '../header';
import { ErrorBoundaryWrapper } from '../ErrorBoundaryWrapper';

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <ErrorBoundaryWrapper>
      <div className='bg-white min-h-screen flex flex-col h-full overflow-hidden'>
        {/* Mobile sidebar overlay */}
        {sidebarOpen && (
          <div
            className='fixed inset-0 z-40 bg-black bg-opacity-50 lg:hidden'
            onClick={() => setSidebarOpen(false)}
          />
        )}

        {/* Header component */}
        <Header />

        {/* Page content */}
        <main className='overflow-auto h-full bg-container-primary shadow-md'>
          {children}
        </main>
      </div>
    </ErrorBoundaryWrapper>
  );
};
